<template>
  <div>
    <b-row>
      <b-col
          md="6"
          xl="6"
          style="margin-top: 1em"
      >
        <b-col
            md="12"
            xl="12"
            style="margin-top: 1em"
        >

          <b-card-code title="Zahlungsinfomation">
            <h4>Entfernung: {{ new Intl.NumberFormat().format(this.vData.TripRoute.TripDistanceMeter) }}km<br></h4>
            <hr>
            <h4>Fahrzeit (Mit Fahrgast): ca. {{ parseInt(this.vData.TripRoute.TripDuration / 60) }} Minuten ({{ (parseInt(this.vData.TripRoute.TripDuration / 60) / 60).toFixed(2) }}h)</h4>
            <h4>Fahrzeit: ca. {{ parseInt(this.vData.TripRoute.TripFullDuration / 60) }} Minuten ({{ (parseInt(this.vData.TripRoute.TripFullDuration / 60) / 60).toFixed(2) }}h)</h4>
            <hr>
            <h4>Taxipreis 1-3 Personen: ca. {{ this.$options.filters.currency(this.vData.Taxipreis) }}</h4>
            <h4>Taxipreis 4-8 Personen: ca. {{ this.$options.filters.currency(this.vData.Taxipreis2) }}</h4>
            <hr>
            <h4>Unser Preis 1-3 Personen: {{ this.$options.filters.currency(this.vData.Price) }}</h4>
            <h4>Unser Preis 4-8 Personen: {{ this.$options.filters.currency(this.vData.Price2) }}</h4>

            <b-row>
              <b-col
                  md="5"
                  xl="5"
                  style="margin-top: 2.3em"
              >
                <b-button
                    class="col-12"
                    variant="info"
                    @click="LoadCustomer"
                >
                  <span v-show="!loading.base"> Angebot berechnen  </span>
                  <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
                  <div
                      v-show="loading.base"
                      class="spinner-border spinner-border-sm"
                      role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </b-button>


              </b-col>
              <b-col
                  md="2"
                  xl="2"
                  style="margin-top: 2.3em"
              >

              </b-col>
              <b-col
                  md="5"
                  xl="5"
                  style="margin-top: 2.3em"
              >
                <b-button
                    class="col-12"
                    v-show="vData.Price > 0 && offer.Email != ''"
                    :variant="'success'"
                    @click="SendOffer"
                >
                  <span v-show="!loading.base"> Angebot versenden  </span>
                  <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
                  <div
                      v-show="loading.base"
                      class="spinner-border spinner-border-sm"
                      role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </b-button>

              </b-col>
            </b-row>
          </b-card-code>
        </b-col>
        <b-col
            md="12"
            xl="12"
            style="margin-top: 1em"
        >
          <b-card-code title="E-Mail">
            <feather-icon
                size="14"
                icon="Trash2Icon"
                class="mr-50 float-right cursor-pointer"
                @click="ResetMail"
            />

            <b-form-group
                label="E-Mail Adresse"
                label-for="email"
            >
              <b-form-input
                  id="email"
                  v-model="offer.Email"
                  size="sm"
              />
            </b-form-group>

            <quill-editor
                v-model="offer.Body"
                :options="editorOption"
            >
              <div
                  id="toolbar"
                  slot="toolbar"
                  class="text-white"
              >
                <!-- Add a bold button -->
                <button class="ql-bold">
                  Boldsadasd
                </button>
                <button class="ql-italic">
                  Italic
                </button>

                <!-- Add font size dropdown -->
                <select class="ql-size">
                  <option value="small"/>
                  <!-- Note a missing, thus falsy value, is used to reset to default -->
                  <option selected/>
                  <option value="large"/>
                  <option value="huge"/>
                </select>

                <select class="ql-font">
                  <option selected="selected"/>
                  <option value="serif"/>
                  <option value="monospace"/>
                </select>

                <!-- Add subscript and superscript buttons -->
                <button
                    class="ql-script"
                    value="sub"
                />
                <button
                    class="ql-script"
                    value="super"
                />

              </div>
            </quill-editor>
          </b-card-code>
        </b-col>
      </b-col>
      <b-col
          md="6"
          xl="6"
          style="margin-top: 1em"
      >
        <b-col
            md="12"
            xl="12"
            style="margin-top: 1em"
            v-for="(so,index) in vData.AddressList"
        >
          <div class="p-1" style="background-color: #292f46;border-radius: 0.5em">
            <b-row class="float-right mr-1 mt-1" @click="removeAddress(index)" style="cursor: pointer">
              <feather-icon
                  size="14"
                  icon="Trash2Icon"
                  class="mr-50"
              />
            </b-row>
            <b-tabs pills>
              <b-tab :title="'Adresse ' + (index+1)">
                <b-row>
                  <b-col
                      md="4"
                      xl="4"
                  >
                    <b-form-group
                        label="Postleitzahl"
                        :label-for="'ZipCode'+index"
                    >
                      <b-form-input
                          :id="'ZipCode'+index"
                          v-model="vData.AddressList[index].ZipCode"
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                      md="4"
                      xl="4"
                  >
                    <b-form-group
                        label="Ort"
                        label-for="Location"
                    >
                      <b-form-input
                          id="Location"
                          v-model="so.Location"
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                      md="4"
                      xl="4"
                  >
                    <b-form-group
                        label="Ortsteil"
                        label-for="District"
                    >
                      <b-form-input
                          id="District"
                          v-model="so.District"
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                      md="9"
                      xl="9"
                  >
                    <b-form-group
                        label="Adresse"
                    >
                      <b-form-input
                          v-model="so.Street"
                          :zip-code="so.ZipCode"
                          :location="so.Location"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                      md="3"
                      xl="3"
                  >
                    <b-form-group
                        label="."
                    >
                      <b-dropdown
                          variant="dark"
                          size="sm"
                          text="Adressen"
                      >
                        <b-dropdown-item @click="AddAddressAddress(index, 'Terminalring 11', '04435', 'Schkeuditz')">
                          Flughafen (LEJ)
                        </b-dropdown-item>
                        <b-dropdown-item @click="AddAddressAddress(index, 'Willy-Brandt-Platz', '04109', 'Leipzig')">
                          Hauptbahnhof Leipzig
                        </b-dropdown-item>
                      </b-dropdown>
                      <b-button
                          class="btn-sm btn-info float-right"
                          @click="AddAddress(index)"
                      >
                        Weitere Adresse
                      </b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-col>
    </b-row>

  </div>
</template>

<script>
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Remark from '@/views/voucher/Remark'
import Ripple from 'vue-ripple-directive'
import EuroField from '@/views/voucher2/EuroFild.vue'
import Cleave from 'vue-cleave-component'
import BCardCode from '@core/components/b-card-code'
import {
  BAlert,
  BTable,
  BFormCheckbox,
  BBadge,
  BFormSelect,
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem,
  BPopover,
  BTab,
  BTabs,
  BInputGroupPrepend,
  BInputGroupAppend,
  VBTooltip, BInputGroup, BSpinner, BFormDatepicker
} from 'bootstrap-vue'
import { VueAutosuggest } from 'vue-autosuggest'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import price from '../administration/Price.vue'
import AddressSearch from '@/views/extras/AddressSearch.vue'
import AddressAutocomplete from '@/views/extras/AddressAutocomplete.vue'

export default {
  name: 'VoucherMask',
  computed: {
    price() {
      return price
    }
  },
  components: {
    quillEditor,
    AddressSearch,
    AddressAutocomplete,
    BAlert,
    BFormCheckbox,
    BTab,
    BTabs,
    EuroField,
    BFormSelect,
    Cleave,
    BTable,
    Remark,
    BCardCode,
    VueAutosuggest,
    BPopover,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BRow,
    BCol,
    BButton,
    BBadge,
    BInputGroupPrepend,
    BInputGroupAppend,
    BSpinner,
    BFormDatepicker
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: '#toolbar',
        },
      },
      ReplacedBody: '',
      defaultAddressEntry: {
        Street: '',
        ZipCode: '',
        Location: '',
        District: '',
      },
      mailText: [],
      loading: {
        base: false,
        price: false,
      },
      Customer: {
        IdentId: 0,
        Number: '',
        Name: ''
      },
      offer: {
        Body: '',
        Email: "",
      },
      vData: {
        TripRoute: {
          TripDistanceMeter: 0,
          TripFullDistanceMeter: 0,
          TripDuration: 0,
          TripFullDuration: 0,
        },
        AddressList: [{
          Street: '',
          ZipCode: '',
          Location: '',
          District: '',
        }, {
          Street: '',
          ZipCode: '',
          Location: '',
          District: '',
        }],
      }
    }
  },
  mounted() {
    this.LoadMail();
  },
  methods: {
    AddAddressAddress(index, Street, ZipCode, Location) {
      this.vData.AddressList[index].Street = Street;
      this.vData.AddressList[index].ZipCode = ZipCode;
      this.vData.AddressList[index].Location = Location;
    },
    AddAddress(index) {
      const newAddressEntry = { ...this.defaultAddressEntry }
      this.vData.AddressList.splice(index + 1, 0, newAddressEntry)
    },
    removeAddress(index) {
      if (this.vData.AddressList.length > 2) {
        this.vData.AddressList.splice(index, 1)
      }
    },
    async LoadMail() {
      await this.$http.get('/mail/template/show?identName=customer_price_offer2')
          .then(resp => {
            console.log("=====================")
            console.log(resp)
            this.offer.Body = resp.data.data.Body;
            this.OrginalBody = resp.data.data.Body;

          })
          .catch(err => {
            console.error(err)
          })
    },
    ResetMail() {
      this.offer.Body = this.OrginalBody;
    },
    async LoadCustomer() {
      this.ResetMail();
      if (this.Customer.Number == '') {
        this.Customer.Number = 'BAR'
      }

      localStorage.lastVoucher_CustomerNumber = this.Customer.Number
      await this.$http.get(`/customer/customerNumber/${this.Customer.Number}`)
          .then(resp => {
            this.Customer.IdentId = resp.data.IdentId
            this.Customer.Name = resp.data.Name
            this.vData.Customer = resp.data.IdentId
            this.vData.PaymentMethod = resp.data.PaymentMethod

          })
          .catch(err => {
            console.error(err)
          })
      await this.GetPrice()
    },
    async GetPrice() {
      this.loading.price = true
      await this.CalculatePrice()
      this.loading.price = false
    },
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    SendOffer() {
      this.$http.post('/voucher/send/offer2', JSON.stringify(this.offer))
          .then(resp => {
            if (resp.data.success) {
              this.$nextTick(() => {
                this.$router.push({ name: 'Voucherlist' })
                this.$nextTick(() => {
                  this.$router.push({ name: 'AddOfferMask' })
                })
              })
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Info',
                      icon: 'CheckIcon',
                      text: `Angebot wurde versendet.`,
                      variant: 'success',
                    },
                  },
                  {
                    timeout: 5000,
                  })
            }
          })
          .catch(err => {
            console.error(err)
          })

    },
    async CalculatePrice() {
      let TravelDay = new Date()
      TravelDay.setHours(TravelDay.getHours() + 24)
      let lastIndex = this.vData.AddressList.length - 1
      let stopovers = []



      Object.keys(this.vData.AddressList).forEach(key => {
        if(key != 0 && key != lastIndex) {
          let so = {
            Address: this.vData.AddressList[key],
            Contact: {
              Name: '',
              Firstname: '',
              Phone: '',
              Phone2: '',
              Fax: '',
              Email: '',
              Web: ''
            },
            PickupTime: '22:55',
            InfoText: ''
          }

          stopovers.push(so)
        }
      })
      await this.$http.post('/voucher/calculatePrice', JSON.stringify({
        'fromId': 0,
        'toId': 0,
        'from': {
          'street': this.vData.AddressList[0].Street,
          'zipCode': this.vData.AddressList[0].ZipCode,
          'location': this.vData.AddressList[0].Location,
          'district': this.vData.AddressList[0].District
        },
        'to': {
          'street': this.vData.AddressList[lastIndex].Street,
          'zipCode': this.vData.AddressList[lastIndex].ZipCode,
          'location': this.vData.AddressList[lastIndex].Location,
          'district': this.vData.AddressList[lastIndex].District
        },
        Stopovers: stopovers,
        'travelDay': TravelDay

      }))
          .then(resp => {

            let first = this.vData.AddressList[0].Street + ", " + this.vData.AddressList[0].ZipCode + " " + this.vData.AddressList[0].Location + (this.vData.AddressList[0].District == "" ? "" : " " + this.vData.AddressList[0].District);
            let last = this.vData.AddressList[lastIndex].Street + ", " + this.vData.AddressList[lastIndex].ZipCode + " " + this.vData.AddressList[lastIndex].Location + (this.vData.AddressList[lastIndex].District == "" ? "" : " " + this.vData.AddressList[lastIndex].District);
            this.offer.Body = this.offer.Body.replace("[[ADDRESS-FIRST]]", first)
            this.offer.Body = this.offer.Body.replace("[[ADDRESS-LAST]]", last)
            let stopoverText = "";
            Object.keys(this.vData.AddressList).forEach(key => {
              if(key != 0 && key != lastIndex) {
                let District = this.vData.AddressList[key].District == "" ? "" : " " + this.vData.AddressList[key].District
                let ZipCode = this.vData.AddressList[key].ZipCode == "" ? "" : " " + this.vData.AddressList[key].ZipCode;
                let Street = this.vData.AddressList[key].Street == "" ? "" : " " + this.vData.AddressList[key].Street;
                let Location = this.vData.AddressList[key].Location == "" ? "" : " " + this.vData.AddressList[key].Location;

                stopoverText += Street + ZipCode  + Location + District +",";
              }
            })


            this.offer.Body = this.offer.Body.replace("[[ADDRESS-STOPOVER]]", this.vData.AddressList.length > 2 ? "über " + stopoverText : "")

            console.log(resp)
            this.vData.Price = (resp.data.route.Price + parseFloat(resp.data.route.Enter1)).toFixed(2)
            this.vData.Taxipreis = (resp.data.route.Taxi + parseFloat(resp.data.route.Enter1)).toFixed(2)

            this.vData.Price2 = (resp.data.route.Price + parseFloat(resp.data.route.Enter2)).toFixed(2)
            this.vData.Taxipreis2 = (resp.data.route.Taxi + parseFloat(resp.data.route.Enter2)).toFixed(2)

            this.zoneName = 'Preis: ' + resp.data.route.Name

            this.vData.TripRoute.TripDistanceMeter = resp.data.route.Distance
            this.vData.TripRoute.TripFullDistanceMeter = resp.data.route.TripFullDistanceMeter
            this.vData.TripRoute.TripDuration = resp.data.route.TripDuration
            this.vData.TripRoute.TripFullDuration = resp.data.route.TripFullDuration


            this.offer.Body = this.offer.Body.replace("[[PRICE]]", this.FormatEuro(this.vData.Price))
            this.offer.Body = this.offer.Body.replace("[[PRICE-3-7]]", this.FormatEuro(this.vData.Price2))

          })
          .catch(err => {
            console.error(err)
          })
    },
  }
}
</script>
